import _ from 'lodash'
import { useGetSelectedDateRange } from "../../../../common/contexts/DateSelector"
import { useGenericPostRequestQuery, useGetAllCourierPartnersQuery } from "../../../../redux/commonRTK"
import { apiConstants } from "../../../../common/constants"
import { getMerchant } from "../../../../helpers/ReduxHelpers"

export default function useFakeData() {
    const { id } = getMerchant()
    const { from_date, to_date } = useGetSelectedDateRange()

    const requestPayload = {
        andfilter: [{ "field": "is_deleted", "operator": "eq", "value": '0' }],
        offset: 0, limit: 500, includes: "id,name,parent,prozoId"
    }
    const { data: allCouriers = [] } = useGetAllCourierPartnersQuery(requestPayload)

    const skip = !from_date || !to_date
    const request = { from_date, to_date, merchantId: id }

    const { data: fakeData, isLoading, isFetching } = useGenericPostRequestQuery({
        url: apiConstants.GET_FAKE_NDR,
        data: request
    }, { skip })

    if (isLoading || isFetching) return { isLoading: true }

    const couriersGroupedById = _.groupBy(allCouriers, 'id')

    const filteredData = (fakeData || []).map(item => {
        const courier = couriersGroupedById[item.courierId]?.[0]
        const courierName = courier ? (courier.parent || courier.name) : item.courierId
        return { ...item, courierName, courier: item.courierId }
    })

    const dataGroupedByCourierOrMerchant = _(filteredData)
        .groupBy('courier')
        .map(function (data, courierId) {
            const courier = couriersGroupedById[courierId]?.[0]
            const name = courier ? (courier.parent || courier.name) : courierId
            return { name, count: data.length }
        })
        .orderBy('count', 'desc')
        .take(20)
        .value()

    const dataGroupedByPaymentMode = _(filteredData)
        .groupBy('paymentMode')
        .map(function (items, name) {
            return { name: name || 'Unknown', count: items.length }
        })
        .value()

    const waShipments = _.filter(filteredData, item =>
        item.whatsappconversationHistory && item.whatsappconversationHistory.length > 0
    )
    const fwShipments = _.filter(filteredData, item =>
        item.futworksConversationHistory && item.futworksConversationHistory.length > 0
    )

    return {
        filteredData,
        dataGroupedByCourierOrMerchant,
        dataGroupedByPaymentMode,
        isLoading: false,
        totalFake: filteredData.length,
        fakeWhatsApp: waShipments.length,
        fakeTelecalling: fwShipments.length,
    }
}
